import { useState, useContext, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation, useNavigate, Link } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Soft UI Dashboard PRO React example components
import Sidenav from "examples/Sidenav";
// Soft UI Dashboard PRO React themes
import theme from "assets/theme";

// Soft UI Dashboard PRO React routes
import routes from "routes";
import adminRoutes from "adminRoutes";

// Soft UI Dashboard PRO React contexts
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brand from "assets/images/logo-ct.png";

import SignIn from "pages/signin";
import SignUp from "pages/signup";
import SignUpNew from "pages/signup-new";

import ResetPassword from "pages/reset-password";
import ClaimMa from "pages/claim/ma"; //manufacturer claim page
import VerifyEmail from "pages/verify-email"; //email verify successful page
import NewPortfolioPage from "pages/de/new-portfolio";

import api from "services/api";

//import AntdApp from "pages/antd";

import { AccountContext } from "context/account";
import { StoreContext } from "context/store";
import CounterContext from "context/counter";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

import Error404 from "pages/error/404";
import Configurator from "examples/Configurator";
import Footer from "examples/Footer";

import Icon from "@mui/material/Icon";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import MessagePanel from "pages/messages/messagepanel";
import NotificationPanel from "pages/messages/notificationpanel";
import Drawer from "@mui/material/Drawer";
import { MAX_SCREEN_WIDTH } from "utils/data";

import { socket } from "services/request";
import qs from "query-string";
import ReactGA from "react-ga4";
import { notification } from "antd";
import moment from "moment";
import parse from "html-react-parser";
import UpStyledLogo from "components/UpStyled/UpStyledLogo";
import TutorialModal from "pages/tutorial/TutorialModal";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

let delayDebounceFns = [];
let deRoutes = routes.filter((x) => !x.account_type || x.account_type == "de");
let maRoutes = routes.filter((x) => !x.account_type || x.account_type == "ma");

export default function App() {
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  var show_notification = (urlObj?.query.show_notification ?? "false") === "true";
  var show_messages = (urlObj?.query.show_messages ?? "false") === "true";
  var init_rightdrawer = show_notification ? 2 : show_messages ? 1 : 0;

  const [controller, dispatch] = useSoftUIController();
  let navigate = useNavigate();

  const { miniSidenav, direction, layout, openConfigurator, sidenavColor, setLayout } = controller;
  const account = useContext(AccountContext);
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [user, setUser] = useState({});
  const [rightDrawer, setRightDrawer] = useState(init_rightdrawer);
  const [tutorialVisible, setTutorialVisible] = useState(false);

  const { pathname, search } = useLocation();
  const { getNewMessageCount, getUnreadMessageCount, setUnreadRequestCount } =
    useContext(CounterContext);
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [currentEvents, setCurrentEvents] = useState([]);

  let uid = localStorage.getItem("uid");

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: pathname + search });
  }, [pathname, search]);

  useEffect(() => {
    setRightDrawer(init_rightdrawer);
  }, [pathname]);

  useEffect(() => {
    setRightDrawer(init_rightdrawer);
    if (!isNoSessionRoute() && account.id) {
      retrieveEvents();
    }
  }, [account]);

  useEffect(() => {
    if (account.id) {
      //let delayDebounceFn;
      /*
      socket.on("project:create", (args) => {
        console.log("trigger project create");
      });
         */
      socket.on("project:update", ({ audiences }) => {
        if (audiences && audiences.includes(account.id)) {
          setUnreadRequestCount(1);
        }

        console.log("trigger project update");
      });

      socket.on("reminder:update", (updated) => {
        //remove the existed notification
        const notifyFn = delayDebounceFns.find((x) => x.id == updated.id);
        if (notifyFn?.fn) {
          clearTimeout(notifyFn.fn);
          delayDebounceFns = delayDebounceFns.filter((x) => x.id != updated.id);
        }
        addReminderNotification(updated);
        console.log("trigger reminder time update");
      });

      socket.on("reminder:create", (created) => {
        addReminderNotification(created);
        console.log("trigger reminder time create");
      });

      socket.on("event:update", (updated) => {
        //remove the existed notification
        const notifyFn = delayDebounceFns.find((x) => x.id == updated.id);
        if (notifyFn?.fn) {
          clearTimeout(notifyFn.fn);
          delayDebounceFns = delayDebounceFns.filter((x) => x.id != updated.id);
        }
        addReminderNotification(updated);
        console.log("trigger event time update");
      });

      socket.on("event:create", (created) => {
        addReminderNotification(created);
        console.log("trigger event time create");
      });
      /*
      socket.on("project:update-status", (status) => {
        if (status == "requested" && account.account_type == "ma") {
          setUnreadRequestCount(1); //directly setup value in frontend instead of querying server to aviod peak requests
          
          let randomSecs = Math.random() * 3000 + 3000; // random wait 3~6 seconds

          delayDebounceFn = setTimeout(() => {
            getUnreadMessageCount(account.id);
          }, randomSecs);
          
        }

        console.log("trigger project status update to " + status);
      });
      */

      getUnreadMessageCount(account.id);
      return () => {
        //clearTimeout(delayDebounceFn);
        socket.disconnect();
      };
    }
  }, [account.id]);

  useEffect(() => {
    if (account.id) {
      const newFilteredRoutes = routeMenu(account.role, account.account_type) || [];
      setFilteredRoutes(newFilteredRoutes);
    }
  }, [uid, account.id]);

  useEffect(() => {
    if (currentEvents.length > 0 && account.id) {
      let currentDate = moment().unix();
      for (let i = 0; i < currentEvents.length; i++) {
        if (currentEvents[i].type == "event" || currentEvents[i].type == "reminder") {
          let start_date = moment(currentEvents[i].start_time).unix();
          let delta = (start_date - currentDate - 30) * 1000;
          if (currentEvents[i].type == "event") {
            delta = (start_date - currentDate - currentEvents[i]?.content?.notification) * 1000;
          }

          if (account.id == currentEvents[i].owner_id && delta > 0) {
            const fn = setTimeout(() => {
              const args = {
                message: currentEvents[i].title,
                description:
                  currentEvents[i].type == "event"
                    ? parse(currentEvents[i]?.content?.description)
                    : currentEvents[i]?.content?.description,
                duration: 0,
              };
              notification.open(args);
            }, delta);
            delayDebounceFns.push({ id: currentEvents[i].id, fn });
          }
        }
      }

      return () => delayDebounceFns.forEach((x) => clearTimeout(x.fn));
    }
  }, [currentEvents, account.id]);

  useEffect(() => {
    if (account.id && !account?.metadata?.hide_tutorial) {
      setTutorialVisible(true);
    }
  }, [account.id]);

  const handleHideTutorial = async () => {
    try {
      setTutorialVisible(false);
      if (!account?.metadata?.hide_tutorial) {
        await api.users.update(account.id, {
          metadata: {
            ...account.metadata,
            hide_tutorial: true,
          },
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addReminderNotification = (currentEvent) => {
    let currentDate = moment().unix();
    let start_date = moment(currentEvent.start_time).unix();
    let delta = (start_date - currentDate - 30) * 1000;
    if (currentEvent.type == "event") {
      delta = (start_date - currentDate - currentEvent?.content?.notification) * 1000;
    }
    if (account.id == currentEvent.owner_id && delta > 0) {
      const fn = setTimeout(() => {
        const args = {
          message: currentEvent.title,
          description:
            currentEvent.type == "event"
              ? parse(currentEvent?.content?.description)
              : currentEvent?.content?.description,
          duration: 0,
        };
        notification.open(args);
      }, delta);
      delayDebounceFns.push({ id: currentEvent.id, fn });
    }
  };

  const retrieveEvents = async () => {
    let currentDate = moment();
    try {
      const temp = await api.calendar.listCalendars();
      const calendars = temp?.data?.calendars || [];
      let cids = calendars.map((x) => x.id);
      if (cids.length > 0) {
        const { data } = await api.calendar.listEvents({
          "start_time[gte]": currentDate.toDate().toISOString(),
          calendar_id: cids.join(":"),
        });

        let raw = data?.events || [];
        setCurrentEvents(raw);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const isNoSessionRoute = () => {
    let result = false;
    const noSessionRoutes = [
      "/login",
      "/register",
      "/verify-email",
      "/en/reset-password",
      "/reset-password",
      "/en/login",
      "/en/register",
      "/manufacturer/",
      "/public/portfolio/",
    ];
    for (let i = 0; i < noSessionRoutes.length; i++) {
      if (pathname.startsWith(noSessionRoutes[i])) {
        return true;
      }
    }
  };

  useEffect(() => {
    if (uid && !isNoSessionRoute()) {
      account
        .session()
        .then((data) => {
          localStorage.setItem("uid", data?.user?.id);
        })
        .catch((err) => {
          console.log(err);
          if (window.location.pathname != "/login") {
            navigate(
              `/login?pathname=${window.location.pathname + window.location.search}&hostname=${
                window.location.hostname
              }`,
              { replace: true }
            );
          } else {
            navigate(`/login`, { replace: true });
          }
        });
    }
  }, [uid]);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            path={route.route}
            element={
              <RequireAuth>
                <DefaultNavbar
                  routes={[...filteredRoutes]}
                  rightDrawer={rightDrawer}
                  setRightDrawer={setRightDrawer}
                  transparent={false}
                />
                <PageLayout route={route} sx={route?.fullWidth ? { px: 0 } : {}}>
                  <SuiBox
                    sx={{
                      maxWidth: route?.fullWidth ? "100%" : MAX_SCREEN_WIDTH,
                      margin: "auto",
                      minHeight: "80vh",
                    }}
                  >
                    {route.component}
                  </SuiBox>
                  {route?.noFooter ? null : (
                    <SuiBox display="flex" justifyContent="center" alignItems="center">
                      <Footer color="text" />
                    </SuiBox>
                  )}
                  {rightDrawer > 0 && (
                    <SuiBox
                      sx={{
                        position: "absolute",
                        top: "60px",
                        right: "0px",
                        zIndex: 12000,
                        height: "100%",
                      }}
                      tabindex="-1"
                      onBlur1={(event) => {
                        console.log("event.relatedTarget", event.relatedTarget);
                        console.log("event.target", event.target);
                        if (
                          event.relatedTarget &&
                          event.relatedTarget.tagName != "UL" &&
                          !event.currentTarget.contains(event.relatedTarget)
                        ) {
                          setRightDrawer(0);
                        }
                      }}
                    >
                      <SuiBox sx={{ position: "sticky", top: "0px" }}>
                        {rightDrawer === 1 && <MessagePanel setRightDrawer={setRightDrawer} />}
                        {rightDrawer === 2 && <NotificationPanel setRightDrawer={setRightDrawer} />}
                      </SuiBox>
                    </SuiBox>
                  )}
                </PageLayout>
              </RequireAuth>
            }
            key={route.route}
          />
        );
      }

      return null;
    });
  };
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const configsButton = (
    <SuiBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default" color="inherit">
        settings
      </Icon>
    </SuiBox>
  );

  const routeMenu = (role, type) => {
    if (role == "admin") {
      if (type == "de") {
        return [...deRoutes, ...adminRoutes];
      } else if (type == "ma") {
        return [...maRoutes, ...adminRoutes];
      }
    } else {
      if (type == "de") {
        return [...deRoutes];
      } else if (type == "ma") {
        return [...maRoutes];
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && account.isLoggedIn && !isNoSessionRoute() && (
        <div>
          {/**
          <Configurator />
          {configsButton}
          */}
        </div>
      )}
      <Routes>
        <Route path="/login" element={<SignIn />} key={"login"} />
        {/* <Route path="/register" element={<SignUp />} /> */}
        <Route path="/register" element={<SignUpNew />} />

        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/en/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/en/login" element={<Navigate to="/login" replace={true} />} />
        <Route path="/en/register" element={<Navigate to="/register" replace={true} />} />
        {/* <Route path="/designer-homepage" element={<AntdApp />} /> */}

        <Route path="/manufacturer/:userId" element={<ClaimMa />} />
        <Route
          path="/public/portfolio/:handle"
          element={
            <div>
              <SuiBox
                width="100%"
                px={4}
                mb={2}
                shadow={"none"}
                color={"white"}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                // position="absolute"
                left={0}
                zIndex={3}
                sx={({
                  palette: { transparent: transparentColor, white },
                  functions: { rgba },
                }) => ({
                  backgroundColor: transparentColor.main,
                })}
              >
                <SuiBox component={Link} to="/" py={1.5} lineHeight={1} sx={{ width: 200 }}>
                  <UpStyledLogo sx={{ height: 35 }} />
                </SuiBox>
                <SuiBox display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
                  <SuiButton variant="gradient" color="dark" onClick={() => navigate("/login")}>
                    Sign In
                  </SuiButton>
                  <SuiButton variant="gradient" color="info" onClick={() => navigate("/register")}>
                    Register
                  </SuiButton>
                </SuiBox>
              </SuiBox>
              <PageLayout>
                <SuiBox
                  sx={{
                    maxWidth: "100%",
                    margin: "auto",
                    minHeight: "80vh",
                  }}
                >
                  <NewPortfolioPage editable={false} isPublic={true} />
                </SuiBox>

                <SuiBox display="flex" justifyContent="center" alignItems="center">
                  <Footer color="text" />
                </SuiBox>
              </PageLayout>
            </div>
          }
        />

        {<Route path="/" element={<Navigate to="/dashboard" replace={true} />} />}

        {getRoutes([...routes, ...adminRoutes])}

        <Route
          path="*"
          element={
            <RequireAuth>
              <PageLayout>
                <SuiBox sx={{ maxWidth: MAX_SCREEN_WIDTH, margin: "auto" }}>
                  <Error404 />
                </SuiBox>
                <Footer color="text" />
              </PageLayout>
            </RequireAuth>
          }
        />
      </Routes>
      {tutorialVisible ? (
        <TutorialModal visible={tutorialVisible} handleClose={handleHideTutorial} />
      ) : null}
    </ThemeProvider>
  );
}

const RequireAuth = ({ children }) => {
  const account = useContext(AccountContext);
  let navigate = useNavigate();
  let uid = localStorage.getItem("uid");

  useEffect(() => {
    const autoRenewFn = setInterval(() => {
      api.auth.renew().catch((err) => {
        if (window.location.pathname != "/login") {
          navigate(
            `/login?pathname=${window.location.pathname + window.location.search}&hostname=${
              window.location.hostname
            }`,
            { replace: true }
          );
        } else {
          navigate(`/login`, { replace: true });
        }
      });
    }, 600000); //10mins

    return () => clearTimeout(autoRenewFn);
  }, []);

  if (account.isLoggedIn && uid) {
    return children;
  } else {
    account
      .session()
      .then((data) => {
        localStorage.setItem("uid", data?.user?.id);
        return children;
      })
      .catch((err) => {
        if (window.location.pathname != "/login") {
          navigate(
            `/login?pathname=${window.location.pathname + window.location.search}&hostname=${
              window.location.hostname
            }`,
            { replace: true }
          );
        } else {
          navigate(`/login`, { replace: true });
        }

        return <div />;
      });
    return children;
  }
};
